"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORIGIN = void 0;
const tslib_1 = require("tslib");
const clock_1 = require("./clock");
tslib_1.__exportStar(require("./enums"), exports);
/**
 * Represents some sort of root element or is simply the bottom value of a
 * logical timestamp.
 */
exports.ORIGIN = (0, clock_1.ts)(0 /* SESSION.SYSTEM */, 0 /* SYSTEM_SESSION_TIME.ORIGIN */);
